import * as React from "react"
import { Layout } from "../components/Layout"
import NotFoundBadge from "@components/common/NotFoundBadge"
import { useIsDesktop } from "@components/helpers/useWindowSize"

import image404 from "@images/404.webp"
import image404Tablet from "@images/404-tablet.webp"

export default function NotFoundPage() {
	const isDesktop = useIsDesktop()

	return (
		<Layout
			gaEvent={{
				eventName: "page_view",
				params: {
					page_path: `${
						typeof window !== "undefined" ? window.location.href : "404"
					}`,
					page_title: `404`,
					queryName: "404 page",
				},
			}}
			disableDotDigitalPopOver
			footerMargin="mt-0"
		>
			<div className="max-container flex flex-nowrap">
				<div className="grid grid-cols-2">
					<div className="flex flex-col justify-center col-span-2 lg:col-span-1 p-4 lg:px-10">
						<p className="text-[20px] md:text-[28px] xl:text-[36px] pb-8 xl:pb-20">
							Oops! We can’t seem to find the page you’re looking for.
						</p>

						<p className="text-md lg:text-lg text-[#4F4F4F] pb-4">
							But don’t worry, though! Here’s how you can get back on track:
						</p>

						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-4">
							<NotFoundBadge
								title={"Return to Previous Page"}
								subtitle={"Go back to the last page you visited."}
								buttonLabel={"Go Back"}
								buttonLink={-1}
							/>
							<NotFoundBadge
								title={"Visit Our Home Page"}
								subtitle={"Head back to our homepage to see the latest drops"}
								buttonLabel={"Back to Home"}
								buttonLink={"/"}
							/>
							<NotFoundBadge
								title={"Shop our Best Sellers"}
								subtitle={
									"Discover the best of Blackbough and find your next go-to bikini"
								}
								buttonLabel={"Explore Collections"}
								buttonLink={"/collections/all"}
							/>
							<NotFoundBadge
								title={"Contact Us"}
								subtitle={"Got questions? Our team is here for you"}
								buttonLabel={"Contact Support"}
								buttonLink={"https://blackboughswim.com/pages/contact-us"}
							/>
						</div>
					</div>

					<div className="col-span-2 lg:col-span-1">
						<img 
							className="w-full object-cover"
							src={isDesktop ? image404 : image404Tablet}
							alt="Blackbough 404"
							loading="eager"
						/>
					</div>
					{/* <h1>Page Not Found</h1>
            <p>Sorry, we couldn't find what you were looking for</p> */}
				</div>
			</div>
		</Layout>
	)
}
